import React, {h} from 'preact';
import SellPriceRangeStep from './SellPriceRangeStep';

export default class BuyPriceRangeStep extends SellPriceRangeStep {
    componentDidMount() {
        trackEvent('Flow', 'BuyRequest', 'buyStep1').withGA().withOptimizely();
        trackEvent('Flow', 'BuyRequest', 'buyerLoadedStep2').withGA().withOptimizely();
    }

    choosePriceRange(index) {
        let priceRanges = this.props.parent.state.priceRanges;
        let priceRange = priceRanges[index];
        priceRange.low = priceRange.low || 0;
        priceRange.high = priceRange.high || priceRange.low * 2;
        // if (priceRange.high < 250000) {
        //     var msg = this.props.parent.state.rebateSupported ?
        //         'Unfortunately, agents on our platform currently do not offer commission refund for this price range.' :
        //         'Unfortunately, agents on our platform currently do not service this price range.';
        //     customPopupContent('<center>Thank you for your interest. ' + msg + ' Please check back in a few months.<br/><br/><a href=\'index\' class=\'btn btn-default\'>OK</a></center>','240','auto');
        //     return;
        // }
        $.get('update-buyrequest-json', {location: this.props.location, priceRange: priceRange.low + '-' + priceRange.high}).then(data => {
            this.props.parent.setState({
                agentCount: data.agentCount,
                lowRange: priceRange.low,
                highRange: priceRange.high,
                priceRangeStr: priceRange.rangeStr,
                currentStep: 'BUY_HOME_TYPE',
                priceRangeRank: index + 1
            });
        }).then(() => $.get('check-if-there-are-matching-buy-imd-json')).then(data => {
            if (data.msg) {
                window.location = 'index?msg=' + encodeURI(data.msg);
            }
        });
        this.props.parent.setState({currentStep: 'LOADING'});
    }

    render() {
        return <div className="flow-step">
            <div className="flow-step-text hidden-xs">
                <img className ="icon-desktop" src={global.imageBaseUrl + 'buysell/svg/compare-proposals.svg'} />
                {this.props.rebateSupported ? <div>UpNest home buyers save an average of $20,213 on their agent commissions.</div>: <div>{this.props.agentCount} agents in the {this.props.city} area ready to compete for you.</div>}
                {/* <div>Receive commission refund from top buyer agents in {this.props.city ? this.props.city : this.props.location}.</div> */}
            </div>

            <div className="flow-step-header-text">
                <strong>What is your price range?</strong>
            </div>

            <div className="option-div">
                <div id="price-ranges-div" className="buy-price-ranges-div">
                    {$(this.props.parent.state.priceRanges.reverse()).map((index, range) => {
                        return <div onClick={() => this.choosePriceRange(index)} className="choice-button price-range-button">
                            <img src={global.imageBaseUrl + 'buysell/svg/price-tier' + (index + 1) + '.svg'}/>
                            <div style={{overflow: 'hidden'}}>
                                <span className="button-text">
                                    {range.rangeStr}
                                </span>
                            </div>
                        </div>;
                    }).get()}
                </div>
            </div>

            <div className="flow-spacer"/>

            <div className="bottom-banner">
                <div className="status-normal">
                    <div className="title"><img src={global.imageBaseUrl + 'buysell/svg/compare-proposals.svg'}/> Compare Proposals</div>
                    {this.props.rebateSupported ? <div className="subtitle subtitle-large">UpNest home buyers save an average of $20,213 on their agent commissions.</div>: <div className="subtitle subtitle-large">{this.props.agentCount} agents in the {this.props.city} area ready to compete for you.</div>}
                </div>
                <div className="status-normal subtitle subtitle-small">
                    {this.props.rebateSupported ? `UpNest home buyers save an average of $20,213 on their agent commissions.`: `${this.props.agentCount} agents in the ${this.props.city} area ready to compete for you.`}
                </div>
            </div>
        </div>;
    }
}
